// Learn TypeScript:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/life-cycle-callbacks.html

import BasePopUpLayer from "../../../../../engines/components/BasePopUpLayer";
import BaseStateSprite from "../../../../../engines/components/state/BaseStateSprite";
import O1HD from "../../../../../engines/gameEngine";
import utilsModel from "../../../../../engines/libs/utilsModel";
import utilsView from "../../../../../engines/libs/utilsView";
import CsvDataManage from "../../../../../engines/managers/CsvDataManage";
import { CsvFileKind } from "../../../../define/CsvFileKind";
import { FileKind } from "../../../../define/FileKind";
import { GeneralKind } from "../../../../define/GeneralKind";
import { SettleLawsuitKind } from "../../../../define/SettleLawsuitKind";
import getOneBundle, { BUNDLE_SMALL_NAME } from "../../../BundleResourceConfig";

const {ccclass, property} = cc._decorator;

const c_fontMin = 44;
const c_fontMax = 53;

const c_fontFeatureMin = 36;
const c_fontFeatureMax = 42;
/** 五官资源路径 */
const c_featuresPath = 'res/main/';
@ccclass
export default class SettleLawsuitMainSelect extends BasePopUpLayer {

	@property({ type: cc.Button, displayName:'' })
	btnStart: cc.Button = null;

	@property({ type: cc.Label, displayName:'' })
	labelSpeak: cc.Label = null;

	@property({ type: cc.Node, displayName:'' })
	peopleList: cc.Node = null;

	@property({ type: BaseStateSprite, displayName:'' })
	btnFeature: BaseStateSprite = null;

	@property({ type: BaseStateSprite, displayName:'' })
	btnLip: BaseStateSprite = null;

	@property({ type: BaseStateSprite, displayName:'' })
	btnNose: BaseStateSprite = null;

	@property({ type: BaseStateSprite, displayName:'' })
	btnEye: BaseStateSprite = null;

	@property({ type: BaseStateSprite, displayName:'' })
	btnEyebrow: BaseStateSprite = null;

	@property({ type: cc.Sprite, displayName:'' })
	sprHair: cc.Sprite = null;

	@property({ type: cc.Sprite, displayName:'' })
	sprFeature: cc.Sprite = null;

	@property({ type: cc.Sprite, displayName:'' })
	sprLip: cc.Sprite = null;

	@property({ type: cc.Sprite, displayName:'' })
	sprNose: cc.Sprite = null;

	@property({ type: cc.Sprite, displayName:'' })
	sprEyebrow: cc.Sprite = null;

	@property({ type: cc.Sprite, displayName:'' })
	sprEye: cc.Sprite = null;

	@property({ type: BaseStateSprite, displayName:'' })
	sprHead: BaseStateSprite = null;

    private csvInfo: any = null;
    /** 五官数据组 */
    private featuresArrData = {};
    private featuresArrIndex = {};
    /** 证人说话索引 */
    private curSpeakArr: number[] = [];

    private bHair = false;
    // LIFE-CYCLE CALLBACKS:

    // onLoad () {}

    start () {
        this.featuresArrData = this._carryData.featuresArrData;
        this.initLayer();
    }

    initLayer() {
        this.csvInfo = CsvDataManage.instance.getCsvData(CsvFileKind.CsvFile.LEGAL_CASE_MAIN_ATTRIBUTE);
        if (!this.csvInfo) {
            console.error(`数据获取失败`);
            return;
        }

        this.initFeaturesData();
        
        this.setBtnSelectState(this.btnFeature, false, true);
        this.setBtnSelectState(this.btnLip, false, true);
        this.setBtnSelectState(this.btnNose, false, true);
        this.setBtnSelectState(this.btnEye, false, true);
        this.setBtnSelectState(this.btnEyebrow, false, true);
        
        this.showPeopleList();
        this.witnessSpeak(0);
        this.refreshStartButton();
    }

    showPeopleList() {  
        let count = 4;
        let csvMain = this._carryData.csvInfo;
        let children = this.peopleList.children;
        for (let i = 1; i<= count; i++) {
            let eyewitness_head = csvMain['eyewitness_head' + i];
            let nodeItem = children[i-1];
            let headNode = nodeItem.getChildByName('sprHead').getComponent(cc.Sprite);
            this.loadIcon(headNode,  `res/main/witness/${eyewitness_head}`);
            // let sprSelect = nodeItem.getChildByName('sprSelect');
        }
    }

    async loadIcon(sprNode: cc.Sprite, spPath: string) {
        if(spPath && spPath != ""){
            let bundle = await getOneBundle( BUNDLE_SMALL_NAME.settleLawsuitBundle );
            bundle.load(
                spPath
                , cc.SpriteFrame,(err,spr:cc.SpriteFrame)=>
                {
                    if(err){
                        console.log("加载背包图片失败",err);
                    }else{
                        if(sprNode && sprNode.isValid){
                            sprNode.spriteFrame = spr;
                        }
                    }
                }
            );
        }
    }

    initFeaturesData() {
       
        let csvMain = this._carryData.csvInfo;
        // let sexType = this._carryData.sexType;
        let sexType = csvMain.sex;
        let bHair = this.bHair = csvMain.is_hair == GeneralKind.EnableState.ENABLED;
        this.sprHead.setFill(sexType != SettleLawsuitKind.SexType.MEN);
        if (!bHair) {
            let defaultHair = csvMain.default_hair;
            this.loadSprite(this.sprHair, defaultHair);
        }
    }

    async loadSprite(sprite: cc.Sprite, path: string) {
        let bundle = await getOneBundle( BUNDLE_SMALL_NAME.settleLawsuitBundle);
        bundle.load(c_featuresPath + path, cc.SpriteFrame
            , (err,imgs:cc.SpriteFrame)=>
            {
                if(err){
                    console.log(err);
                }else{
                    // sprite.node.active = true;
                    sprite.spriteFrame = imgs;
                }
            }
        );
    }

    setBtnSelectState(btn: BaseStateSprite, bSelect: boolean, bFirst: boolean = false) {
        if (!bFirst && btn.isFill == bSelect) {
            return;
        }
        btn.setFill(bSelect);

        let label = cc.find('Label', btn.node).getComponent(cc.Label);
        let labelOutline = label.node.getComponent(cc.LabelOutline);
        labelOutline.enabled = bSelect;

        let fontSize = 0;
        if (btn != this.btnFeature) {
            fontSize = bSelect ? c_fontMax : c_fontMin;
        } else {
            fontSize = bSelect ? c_fontFeatureMax : c_fontFeatureMin;
        }
        label.fontSize = fontSize;
    }

    /**
     * 切换选择
     * @param typeId 
     * @param sprite 
     */
    switchSelect(typeId: SettleLawsuitKind.FeaturesType, sprite: cc.Sprite) {
        let csvInfo = this.csvInfo;
        let title = csvInfo.title;
        let idx = 0;
        if (!this.featuresArrIndex[typeId] && this.featuresArrIndex[typeId] != 0) {
            idx = 0;
        } else {
            let len = this.featuresArrData[typeId].length;
            idx = this.featuresArrIndex[typeId] + 1;
            idx %= len;
        }
        this.featuresArrIndex[typeId] = idx;
        let info = this.featuresArrData[typeId][idx];
        
        this.loadSprite(sprite, info[title.icon]);
        this.refreshStartButton();
    }

    refreshStartButton() {
        let selectArr = [this.btnFeature, this.btnLip, this.btnNose, this.btnEye, this.btnEyebrow];
        
        for (let o of selectArr) {
            if (!o.isFill) {
                this.btnStart.interactable = false;
                return;
            }
        }
        this.btnStart.interactable = true;
    }

    onClickStart() {
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        let selectArr = [this.btnFeature, this.btnLip, this.btnNose, this.btnEye, this.btnEyebrow];
        
        for (let o of selectArr) {
            if (!o.isFill) {
                O1HD.getModules().uiControlModule.showMessageBox("请完成画像");
                return;
            }
        }
        this.destroyNode();
        this.showResult();
    }   

    showResult() {
        // let csvInfo = this.csvInfo;
        // let title = csvInfo.title;
        // let FeaturesType = SettleLawsuitKind.FeaturesType;
        // let correctNum = 0;
        // for (let i in FeaturesType) {
        //     if (!isNaN(Number(i))) {
        //         continue;
        //     }

        //     let typeId = FeaturesType[i];
        //     let idx = this.featuresArrIndex[typeId];
        //     let info = this.featuresArrData[typeId][idx];
        //     let retData = this._carryData.[typeId];

        //     if (info[title.tid] == retData[title.tid]) {
        //         correctNum++;
        //     }
        // }
        
        this._carryData.parent.onClickselelctSuspects(this.featuresArrIndex);
    }

    onClickEye() {
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        this.setBtnSelectState(this.btnEye, true);
        this.switchSelect(SettleLawsuitKind.FeaturesType.EYE, this.sprEye);
    }
    
    onClickEyebrow() {
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        this.setBtnSelectState(this.btnEyebrow, true);
        this.switchSelect(SettleLawsuitKind.FeaturesType.EYEBROW, this.sprEyebrow);
    }

    onClickNose() {
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        this.setBtnSelectState(this.btnNose, true);
        this.switchSelect(SettleLawsuitKind.FeaturesType.NOSE, this.sprNose);
    }

    onClickLip() {
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        this.setBtnSelectState(this.btnLip, true);
        this.switchSelect(SettleLawsuitKind.FeaturesType.LIP, this.sprLip);
    }

    onClickFeature() {
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        this.setBtnSelectState(this.btnFeature, true);
        this.switchSelect(
            SettleLawsuitKind.FeaturesType.FEATURE
            , this.bHair ? this.sprHair : this.sprFeature
        );
    }

    onClickWitness(event: cc.Event.EventTouch, data) {
        this.witnessSpeak(Number(data));
    }

    witnessSpeak(people: number) {
        this.selectPeople(people);
        let pidx = people+1;
        let idx = this.curSpeakArr[people];

        let csvMain = this._carryData.csvInfo;
        let eyewitness_talk = csvMain['eyewitness_talk' + pidx];
        let talkArr = utilsModel.splitLineFeed(eyewitness_talk);

        if (idx == null || idx == undefined) {
            this.curSpeakArr[people] = idx = 0;
        } else {
            idx = this.curSpeakArr[people] = (idx + 1) % talkArr.length;
        }
        
        let name = csvMain['eyewitness_name' + pidx];
        let desc = name + ':' + talkArr[idx];
        this.labelSpeak.string = desc;
    }
    
    selectPeople(idx: number) {
        let children = this.peopleList.children;
        children.forEach((v, i)=> {
            let sprHead = v.getChildByName('sprHead')
            let sprSelect = v.getChildByName('sprSelect');
            sprSelect.active = i == idx;
            sprHead.color = i == idx ? cc.Color.WHITE : cc.Color.GRAY;
        });
    }

    // update (dt) {}
}
